import Dropzone from 'react-dropzone';
import { DropContainer, UploadMessage, ImprovButton } from './styles.js';
import Clip from '../../../../../assets/icons/clip';

const UploadButton = ({ onUpload, id, tenantId, type = 'flow' }) => {
  const renderDragMessage = (isDragActive, isDragReject) => {
    if (!isDragActive) {
      return (
        <ImprovButton>
          <Clip />
          Enviar Anexo
        </ImprovButton>
      );
    }

    if (isDragReject) {
      return <UploadMessage type="error">Arquivo não suportado</UploadMessage>;
    }

    return <UploadMessage type="success">Solte o arquivo aqui</UploadMessage>;
  };

  return (
    <Dropzone
      multiple={false}
      onDropAccepted={(items) => onUpload(items, { id, tenantId, type })}
    >
      {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
        <DropContainer
          {...getRootProps()}
          isDragActive={isDragActive}
          isDragReject={isDragReject}
        >
          <input {...getInputProps()} />
          {renderDragMessage(isDragActive, isDragReject)}
        </DropContainer>
      )}
    </Dropzone>
  );
};

export default UploadButton;
